<template>
  <main class="login-page">
    <header class="auth-header">
      <router-link to="/" class="site-brand">
        <BrandLogo />
      </router-link>
      <router-link to="/login" class="auth-header-link">Entrar</router-link>
    </header>

    <section class="auth-copy">
      <p class="section-label">Comece agora</p>
      <h1>Crie uma conta para organizar documentos jurídicos.</h1>
      <p>Ative o trial com 7 dias e 3 créditos para experimentar geração, validação, evidências e gestão documental no mesmo fluxo.</p>
    </section>

    <section class="login-panel">
      <h1>Criar conta</h1>
      <p>Comece com 7 dias de acesso e 3 créditos para estruturar governança e compliance operacional.</p>

      <v-form @submit.prevent="submit">
        <v-text-field v-model="name" label="Nome completo" outlined dense />
        <v-text-field v-model="email" label="Email de acesso" outlined dense />
        <v-text-field v-model="companyName" label="Empresa (opcional)" outlined dense />
        <v-text-field
          v-model="password"
          label="Senha"
          type="password"
          outlined
          dense
          hint="Minimo 8 caracteres, 1 numero e 1 caractere especial"
          persistent-hint
        />
        <v-text-field v-model="passwordConfirmation" label="Confirmar senha" type="password" outlined dense />
        <v-alert v-if="error" type="error" dense text>{{ error }}</v-alert>
        <v-btn block color="primary" height="44" type="submit" :loading="loading">Criar conta</v-btn>
      </v-form>

      <div class="auth-links">
        <router-link to="/login">Já tenho conta</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import BrandLogo from '../../components/BrandLogo.vue'

export default {
  name: 'RegisterPage',
  components: {
    BrandLogo
  },
  data () {
    return {
      name: '',
      email: '',
      companyName: '',
      password: '',
      passwordConfirmation: '',
      loading: false,
      error: ''
    }
  },
  methods: {
    async submit () {
      this.loading = true
      this.error = ''

      if (!this.isPasswordValid(this.password)) {
        this.error = 'A senha deve ter no minimo 8 caracteres, 1 numero e 1 caractere especial.'
        this.loading = false
        return
      }

      if (this.password !== this.passwordConfirmation) {
        this.error = 'A confirmação de senha não confere.'
        this.loading = false
        return
      }

      try {
        await this.$store.dispatch('auth/register', {
          name: this.name,
          email: this.email,
          password: this.password,
          company_name: this.companyName || undefined
        })
        this.$router.push('/app/dashboard')
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Não foi possível criar sua conta.'
      } finally {
        this.loading = false
      }
    },
    isPasswordValid (value) {
      return String(value || '').length >= 8 &&
        /\d/.test(value) &&
        /[^A-Za-z0-9]/.test(value)
    }
  }
}
</script>
